// Type guard function to check if avatar has icon props
export function hasIconType(props) {
    return !!(props.iconType && props.icon);
}
